import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DashboardComponent } from "./dashboard.component";
import { FuseSharedModule } from "@fuse/shared.module";
import { TranslateModule } from "@ngx-translate/core";
import { RouterModule } from "@angular/router";
import { MatDividerModule } from "@angular/material/divider";
import { MatButtonModule } from "@angular/material/button";
import { TarjetaComponent } from "./components/tarjeta/tarjeta.component";
import { AuthGuard } from "@auth0/auth0-angular";
import { MatIconModule } from "@angular/material/icon";
import { MatChipsModule } from "@angular/material/chips";

const routes = [
    {
        path: "inicio",
        component: DashboardComponent,
        canActivate: [AuthGuard],
        data: {
            allowedRoles: [1, 3, 4],
        },
    },
];

@NgModule({
    declarations: [DashboardComponent, TarjetaComponent],
    imports: [
        RouterModule.forChild(routes),
        CommonModule,
        FuseSharedModule,
        TranslateModule,
        MatDividerModule,
        MatButtonModule,
        MatIconModule,
        MatChipsModule,
    ],
})
export class DashboardModule {}
